export default "__VITE_ASSET__CDl3XKMe__"